var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5793 10.65L12.75 12.75M7.125 4.5C8.36764 4.5 9.375 5.50736 9.375 6.75M12.05 7.15C12.05 9.8562 9.8562 12.05 7.15 12.05C4.4438 12.05 2.25 9.8562 2.25 7.15C2.25 4.4438 4.4438 2.25 7.15 2.25C9.8562 2.25 12.05 4.4438 12.05 7.15Z",
    stroke: "#9A9A9A",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.47264701a30813e8a35bf21e72fcc520.svg";
export { ForwardRef as ReactComponent };